import { render, staticRenderFns } from "./FacialDeviceModal.vue?vue&type=template&id=f51e05bc&scoped=true&"
import script from "./FacialDeviceModal.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51e05bc",
  null
  
)

export default component.exports